//
// jQuery 
//
window.$ = window.jQuery = $ = require('jquery');

//
// Fancybox import
//
var fancybox = require('@fancyapps/fancybox');

//
// Swiper import
//
import Swiper from './libs/swiper.min.js';

//
// maskedinput import
//
import InputMask from "./libs/maskedinput.min.js";

//
// validate import
//
import validate from "./libs/jquery.validate.min.js";

//
// Clone .js-header-search, .js-header-nav, .js-header-whatsapp, .js-header-mail, .js-header-tel, .js-header-cats, .js-header-btns
//

$(document).ready(function () {
    var menu_dropdown = $('.js-header-dropdown').find('.js-header-dropdown-flex');

    $('.js-header-top-nav').clone().appendTo(menu_dropdown);
    $('.js-header-bottom-nav').clone().appendTo(menu_dropdown);
    $('.js-header-tel').clone().appendTo(menu_dropdown);
    $('.js-header-address').clone().appendTo(menu_dropdown);
    $('.js-header-whatsapp').clone().appendTo(menu_dropdown);
    $('.js-header-social').clone().appendTo(menu_dropdown);
    $('.js-header-btn').clone().appendTo(menu_dropdown);
});

//
// Clone .js-header-whatsapp, .js-header-tel
//

$(document).ready(function () {
    var menu_top = $('.js-header-bottom-flex');
    $('.js-header-top .js-header-whatsapp').clone().appendTo(menu_top);
    $('.js-header-top .js-header-tel').clone().appendTo(menu_top);
});

//
// Load more .desc-table 
// 

$(document).ready(function () {
    if ($(".js-video-blog-wrapper .js-video-blog-item").length > 2) {
        var loadmore_btn = '<div class="load-more-video-blog">Загрузить больше видео</div>'
        $(".js-video-blog-wrapper .js-video-blog-item").slice(2, 20).hide();
        $(loadmore_btn).insertAfter($(".js-video-blog-wrapper"));

        $(".load-more-video-blog").on('click', function () {
            $(".js-video-blog-wrapper .js-video-blog-item").slice(2, 20).slideToggle();
            $(this).fadeOut();
        });
    }
});

//
// .label-span append to sibling input  
// 

$('.label-span').each(function () {
    $(this).appendTo($(this).siblings('.wpcf7-form-control-wrap'));
});
//
// add class when input not empty  
// 


$('input[type=text], input[type=email], input[type=tel]').on('keyup focusout', function () {
    setTimeout(() => {
        if (($(this).val()).trim() != "") {
            $(this).addClass('not-empty');
        } else {
            $(this).removeClass('not-empty');
        }
    }, 500);
});


//
// Swiper settings
//

$(document).ready(function () {

    var getTimeout = function () { var e = setTimeout, b = {}; setTimeout = function (a, c) { var d = e(a, c); b[d] = [Date.now(), c]; return d }; return function (a) { return (a = b[a]) ? Math.max(a[1] - Date.now() + a[0], 0) : NaN } }();
    function sanitisePercentage(i) {
        return Math.min(100, Math.max(0, i));
    }

    var percentTime;
    var tick;
    var progressBar = document.querySelectorAll('.js-hero-bar-progress-current');

    var heroSwiper = new Swiper('.hero-swiper', {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.hero-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            prevEl: '.swiper-prev-hero',
            nextEl: '.swiper-next-hero',
        },
        on: {
            slideChange: function () {
                var swiper = this;
                var defaultSlideDelay = swiper.params.autoplay.delay;
                var currentIndex = swiper.realIndex + 1;
                var currentSlide = swiper.slides[currentIndex];
                var currentSlideDelay = currentSlide.getAttribute('data-swiper-autoplay') || defaultSlideDelay;

                updateSwiperProgressBar(progressBar, currentSlideDelay);
            }
        }
    });
    function updateSwiperProgressBar(bar, slideDelay) {

        function startProgressBar() {
            resetProgressBar();
            tick = setInterval(progress, 50);
        }

        function progress() {

            var timeLeft = getTimeout(heroSwiper.autoplay.timeout);

            if (heroSwiper.autoplay.running && !heroSwiper.autoplay.paused) {
                percentTime = sanitisePercentage(100 - Math.round(timeLeft / slideDelay * 100));
                $('.js-hero-bar-progress-current').css('width', percentTime + '%');

                if (percentTime > 100) {
                    resetProgressBar();
                }
            }

            if (heroSwiper.autoplay.paused) {
                percentTime = 0;
                $('.js-hero-bar-progress-current').width(0);
            }

        }

        function resetProgressBar() {
            percentTime = 0;
            $('.js-hero-bar-progress-current').width(0);
            clearInterval(tick);
        }

        startProgressBar();

    }


    var usefulSwiper = new Swiper('.useful-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        pagination: {
            el: '.useful-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            prevEl: '.swiper-prev-useful',
            nextEl: '.swiper-next-useful',
        },
        breakpoints: {
            380: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            998: {
                slidesPerView: 3,
            },
            1300: {
                slidesPerView: 4,
            },
            1450: {
                slidesPerView: 4,
            },
        },
    });

    var brandsSwiper = new Swiper('.brands-swiper', {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        pagination: {
            el: '.brands-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            prevEl: '.swiper-prev-brands',
            nextEl: '.swiper-next-brands',
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3,
            },
            998: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 5,
            },
            1450: {
                slidesPerView: 6,
            },
        },
    });

    var galSwiper = new Swiper('.gal-swiper', {
        slidesPerView: 2.5,
        spaceBetween: 15,
        loop: true,
        pagination: {
            el: '.gal-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            prevEl: '.swiper-prev-gal',
            nextEl: '.swiper-next-gal',
        },
        breakpoints: {
            576: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            998: {
                slidesPerView: 4,
            },
            1300: {
                slidesPerView: 4,
            },
            1450: {
                slidesPerView: 4,
            },
        },
    });

    var kitsThumbs = new Swiper('.kits-thumbs', {
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 20,
        freeMode: {
            enabled: true,
            minimumVelocity: 0.04,
        },
        breakpoints: {
            998: {
                spaceBetween: 44,
                slidesPerView: 'auto',
                allowTouchMove: false,
                longSwipes: false,
                freeMode: false,
                cssMode: false,
            },
        },
    });

    var kitsSwiper = new Swiper('.kits-swiper', {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
        thumbs: {
            swiper: kitsThumbs
        },
    });

    var getTimeoutProblems = function () { var e = setTimeout, b = {}; setTimeout = function (a, c) { var d = e(a, c); b[d] = [Date.now(), c]; return d }; return function (a) { return (a = b[a]) ? Math.max(a[1] - Date.now() + a[0], 0) : NaN } }();
    function sanitisePercentageProblems(i) {
        return Math.min(100, Math.max(0, i));
    }

    var percentTimeProblems;
    var tickProblems;
    var progressBarProblems = document.querySelectorAll('.js-hero-bar-progress-current');

    var problemsThumbs = new Swiper('.problems-thumbs', {
        slidesPerView: 1.6,
        spaceBetween: 15,
        breakpoints: {
            330: {
                slidesPerView: 2,
            },
            998: {
                slidesPerView: 4,
                allowTouchMove: false,
                longSwipes: false,
                freeMode: false,
                cssMode: false,
            },
        },
    });

    var problemsSwiper = new Swiper('.problems-swiper', {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
        loop: true,
        thumbs: {
            swiper: problemsThumbs
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        on: {
            slideChange: function () {
                var swiperProblems = this;
                var defaultSlideDelay = swiperProblems.params.autoplay.delay;
                var currentIndex = swiperProblems.realIndex + 1;
                var currentSlide = swiperProblems.slides[currentIndex];
                var currentSlideDelay = currentSlide.getAttribute('data-swiper-autoplay') || defaultSlideDelay;

                updateSwiperProgressBarProblems(progressBarProblems, currentSlideDelay);
            }
        }
    });
    function updateSwiperProgressBarProblems(bar, slideDelay) {

        function startProgressBarProblems() {
            resetProgressBarProblems();
            tickProblems = setInterval(progressProblems, 50);
        }

        function progressProblems() {

            var timeLeft = getTimeoutProblems(problemsSwiper.autoplay.timeout);

            if (problemsSwiper.autoplay.running && !problemsSwiper.autoplay.paused) {
                percentTimeProblems = sanitisePercentageProblems(100 - Math.round(timeLeft / slideDelay * 100));
                $('.js-problems-bar-progress-current').css('width', percentTimeProblems + '%');

                if (percentTimeProblems > 100) {
                    resetProgressBarProblems();
                }
            }

            if (problemsSwiper.autoplay.paused) {
                percentTimeProblems = 0;
                $('.js-problems-bar-progress-current').width(0);
            }

        }

        function resetProgressBarProblems() {
            percentTimeProblems = 0;
            $('.js-problems-bar-progress-current').width(0);
            clearInterval(tickProblems);
        }

        startProgressBarProblems();

    }
});


//
// Cookie
//

function checkCookies(){
    let cookieDate = localStorage.getItem('cookieDate');
    let cookieNotification = document.getElementById('cookie_notification');
    let cookieBtn = cookieNotification.querySelector('.cookie_accept');

    // Если записи про кукисы нет или она просрочена на 1 год, то показываем информацию про кукисы
    if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
        cookieNotification.classList.add('show');
    }

    // При клике на кнопку, в локальное хранилище записывается текущая дата в системе UNIX
    cookieBtn.addEventListener('click', function(){
        localStorage.setItem( 'cookieDate', Date.now() );
        cookieNotification.classList.remove('show');
    })
}
checkCookies();


//
// target .js-donate-link
//


$(document).ready(function () {
    $('.js-donate-link').click(function () {
        var donate_link = $(this).data('donate-link'),
            donate_link_index = $(this).index();
        var form_block_section = $('#form-block');
        var donate_link_index_plus = donate_link_index + 1;
        $(form_block_section).find('.donate-item').slice(donate_link_index, donate_link_index_plus).trigger('click');

        var heightheader = $(".header").height();
        var top = $(form_block_section).offset().top - heightheader;
        $('body,html').animate({ scrollTop: top }, 800);
    });
});


//
// type file
//

$(document).ready(function () {
    $('input[type=file]').on('change', function () {
        var splittedFakePath = this.value.split('\\');
        if (this.value) {
            $(this).parents('.flex-form-item-file').find('.js-info-group').show().find('.js-info-file').html('<div class="append-text-file"><div class="append-text-file-name">' + splittedFakePath[splittedFakePath.length - 1] + '</div><div class="append-text-file-remove"></div></div>');
        } else {
            $(this).parents('.flex-form-item-file').find('.js-info-group').hide().find('.js-info-file').html('');
        }
    });
    setInterval(() => {
        $('.append-text-file-remove').click(function () {
            $(this).parents('.js-info-group').hide().find('.js-info-file').html();
        });
    }, 500);
});


//
// CF7 form scripts
//

$(document).ready(function () {
    $('.js-form-block').each(function () {
        $(this).find('.js-info-form').appendTo($(this).find('.js-method-payment'));
    });
    $('span.your_price_select select').each(function () {
        $(this).find('option:first-child').text('');
        var html_custom_select = '<div class="custom-select"><div class="custom-select-title">Выбрать</div><div class="custom-select-list"></div></div><svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.625 0.75L7 6.375L1.375 0.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        $(html_custom_select).insertBefore($(this));
        $(this).find('option').clone().appendTo($(this).siblings('.custom-select').find('.custom-select-list'));
    });
    $('.custom-select').each(function () {
        $(this).find('option').each(function () {
            if ($(this).val() != '') {
                var this_value = $(this).val();
                var this_option_deform = '<div data-value="' + this_value + '">' + this_value + '</div>'
                $(this_option_deform).appendTo($(this).parents('.custom-select-list'));
            }
        });
        $(this).find('option').remove();
        $(this).parents('.label-block').click(function () {
            if (!($(this).find('.custom-select').hasClass('is-open'))) {
                $(this).find('.custom-select').addClass('is-open');
                $(this).find('.custom-select').find('.custom-select-list').slideToggle(300);
            } else {
                $(this).find('.custom-select').removeClass('is-open');
                $(this).find('.custom-select').find('.custom-select-list').slideToggle(300);
            }
        });
        $(this).find('.custom-select-list').find('div').click(function () {
            if (!($(this).hasClass('checked'))) {
                $(this).addClass('checked');
                $(this).siblings('.checked').removeClass('checked');
                var this_option_text = $(this).text();
                $(this).parents('.custom-select').find('.custom-select-title').text(this_option_text);
                $(this).parents('.custom-select').siblings('select').find('option').each(function () {
                    var option_active = $(this).parents('select').siblings('.custom-select').find('div.checked').text();
                    if ($(this).val() === option_active) {
                        console.log(123);
                        $(this).prop('selected', true);
                        $(this).parents('.label-block').addClass('is-active');
                    }
                });
            }

        });
    });
    setTimeout(() => {
        $('.js-form-block').each(function () {
            var donate_name = $(this).find('.donate-item.is-selected').text();
            $(this).find('input[name="your_donate"]').val(donate_name);
        });
    }, 500);

    $('.js-form-block').find('.donate-item').click(function (this_block) {
        if (!($(this).hasClass('is-selected'))) {
            $(this).addClass('is-selected').siblings('.donate-item.is-selected').removeClass('is-selected');
            var donate_name = $(this).text();
            $(this).parents('.js-form-block').find('input[name="your_donate"]').val(donate_name);
        }
    });
});

//
// Mask tel
//

$(document).ready(function () {
    $.mask.definitions['~'] = "[0-69]";
    $("[type='tel']").mask("+7 (~99) 999-99-99");
});


//
// Validate settings
//

$(document).ready(function () {
    var output = $('#modal-form').find('.wpcf7-response-output');
    $(output).prependTo($(output).parents('.wpcf7-form'));
    $('.js-form-item').find('input').click(function () {
        $(this).siblings('.wpcf7-not-valid-tip').hide();
    });
});
$('.flex-form').find('input').each(function () {
    $(this).focus(function () {
        $(this).parents('label').addClass('input--onfocus');
    });
    $(this).focusout(function () {
        $(this).parents('label').removeClass('input--onfocus');
    });
});

var Form = {
    init: function () {
        Form.validation();
    },
    validation: function () {
        $('.wpcf7-form:not(.js-form-item)').each(function (i) {
            $(this).validate({
                rules: {
                    your_price_select: {
                        required: true
                    },
                    your_name: {
                        required: true,
                    },
                    your_tel: {
                        required: true,
                    },
                    your_email: {
                        required: true,
                    },
                    your_policy: {
                        required: true,
                    }
                },
                highlight: function (element) {
                    $(element).removeClass('form--valid').addClass('form--error');
                    $(element).parents('label, .label-block').removeClass('label--valid').addClass('label--error');
                },
                unhighlight: function (element) {
                    $(element).removeClass('form--error').addClass('form--valid');
                    $(element).parents('label, .label-block').removeClass('label--error').addClass('label--valid');
                },
                errorPlacement: function (error, element) {
                    var error_label = error.addClass('input-label--error').text();
                    $(element).parents('label, .label-block').find('span.label-span').attr('aria-label-error', error_label);
                },
                messages: {
                    your_name: {
                        required: "Введите",
                    },
                    your_tel: {
                        required: "Введите",
                    },
                    your_policy: {
                        required: "Поставьте галочку",
                    }
                },
            });
        });
    }
}
$(function () { Form.init(); });



//
// Fancybox settings
//

$(document).ready(function () {

    // Skip cloned elements
    $('[data-fancybox]').fancybox({
        backFocus: false,
        loop: true,
    });

    $('.link-youtube').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        helpers: {
            media: {

            }
        }
    });
});

//
// faq block 
// 

$(document).ready(function () {
    $(".js-question").each(function () {
        $(this).not('.is--active').find('.js-ask').hide();
    });
    $(".js-question").click(function () {
        var this_quest = $(this);
        if (this_quest.hasClass('is--active')) {
            this_quest.removeClass('is--active');
            this_quest.find('.js-ask').slideUp();
        } else {
            this_quest.addClass('is--active');
            this_quest.find('.js-ask').slideDown();
            this_quest.siblings(".is--active").find('.js-ask').slideToggle();
            this_quest.siblings(".is--active").removeClass('is--active');
        }
    });
});

//
// From_where to CF7 
//


$(document).ready(function () {
    $('a[href*="#modal"]').addClass('modal-inline');
    var modal_form = $('#modal-form'),
        from_where_default = "";

    function default_after_close() {
        modal_form.find('input[name="from_where"]').removeAttr('value');
    };
    $(".modal-inline").each(function () {
        var this_val = $(this).attr('from_where');
        $(this).fancybox({
            smallBtn: false,
            buttons: [],
            beforeShow: function () {
                setTimeout(function () {
                    modal_form.find('input[name="from_where"]').val(this_val);
                }, 100);
            },
            afterClose: function () {
                default_after_close();
            }
        });
    });
});

//
// cf7 redirect 
//

document.addEventListener('wpcf7mailsent', function (event) {
    window.location.href = "/thanks/"
}, !1);

//
// Heading after scrolling
//

$(document).ready(function () {
    function scrollFixed() {
        if ($(window).scrollTop() > 180) {
            $('.header').addClass('fixed');
            $('.header').slideDown(500);
            $('.to-top-fixed').addClass('fixed');
        } else if ($(window).scrollTop() < 41) {
            $('.header').removeClass('fixed');
            $('.to-top-fixed').removeClass('fixed');
        }
        if ($(window).scrollTop() > 200) {
            $('.to-top-fixed').addClass('fixed');
        } else if ($(window).scrollTop() < 201) {
            $('.to-top-fixed').removeClass('fixed');
        }
    };

    setTimeout(function () {
        scrollFixed();
    }, 100);
    $(window).scroll(function () {
        scrollFixed();
    });
    $('.to-top-fixed, .js-to-top').click(function () {
        $('body,html').animate({ scrollTop: 0 }, 800);
    });
});

//
// Antispam
//

$(document).ready(function () {
    setTimeout(function () {
        jQuery('.antispam').prop('checked', !1)
    }, 500)
});

//
// Menu space for position:fixed settings
//

$(document).ready(function () {
    function heightheader() {
        var heightheader = $("header").height();
        $('.header__space').css('height', heightheader);
        $('.js-header-dropdown').css('padding-top', heightheader);
    };
    setTimeout(function () {
        heightheader();
    }, 50);
    $(window).resize(function () {
        heightheader();
    });
});

//
// Menu hamburger
//

$(document).ready(function () {
    var clickstatus = 0;
    function addClass_menu() {
        $(".js-header-hamburger").addClass('toggled');
        $(".header").addClass('toggled');
        $(".js-header-dropdown").addClass('toggled');
        $(".overlay").addClass('toggled');
        $("body").addClass('menu-toggled');
    }
    function removeClass_menu() {
        $(".js-header-hamburger").removeClass('toggled');
        $(".header").removeClass('toggled');
        $(".js-header-dropdown").removeClass('toggled');
        $(".overlay").removeClass('toggled');
        $("body").removeClass('menu-toggled');
    }
    $(".js-header-hamburger").click(function () {
        if (clickstatus == 0) {
            addClass_menu();
            clickstatus = 1;
        } else if (clickstatus == 1) {
            removeClass_menu();
            clickstatus = 0;
        }
    });
    $(".overlay").click(function () {
        if (clickstatus == 1) {
            removeClass_menu();
            clickstatus = 0;
        }
    });
    $("a").not('.catalog-link').click(function () {
        if (clickstatus == 1) {
            removeClass_menu();
            clickstatus = 0;
        }
    });
});

//
// Load more
//

$(document).ready(function () {
    $(".js-archive-item").slice(0, 4).show();
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".js-archive-item:hidden").slice(0, 4).slideDown();
        if ($(".js-archive-item:hidden").length == 0) {
            $("#loadMore").fadeOut('slow');
        }
    });
    if ($(".js-archive-item:hidden").length == 0) {
        $("#loadMore").fadeOut('slow');
    }
});

